import { useState, useEffect } from 'react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Services', href: '#value' },
    { label: 'How It Works', href: '#how-it-works' },
    { label: 'Pricing', href: '#pricing' },
    { label: 'Clients', href: '#clients' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-dark-base/95 backdrop-blur-md border-b border-neon-green/20' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        <a href="#" className="flex items-center gap-3">
          <img
            src="https://static.readdy.ai/image/17c770440fc9a0cd846fe980a29eae0b/c9649332f864171b785bcdb8261515ed.png"
            alt="MartLed Logo"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </a>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-sm font-rajdhani font-semibold tracking-widest uppercase text-gray-300 hover:text-neon-green transition-all duration-300 relative group"
            >
              {link.label}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-neon-green group-hover:w-full transition-all duration-300" style={{ boxShadow: '0 0 8px #39ff14' }} />
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-4">
          <a
            href="#contact"
            className="px-6 py-2.5 rounded-full font-rajdhani font-bold tracking-widest uppercase text-sm text-black bg-neon-green hover:scale-105 transition-all duration-300 whitespace-nowrap"
            style={{ boxShadow: '0 0 20px rgba(57,255,20,0.5)' }}
          >
            Get a Quote
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-neon-green"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl`} />
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-dark-base/98 border-t border-neon-green/20 px-4 py-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="font-rajdhani font-semibold tracking-widest uppercase text-gray-300 hover:text-neon-green transition-colors duration-300 py-2"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setMobileOpen(false)}
            className="mt-2 px-6 py-3 rounded-full font-rajdhani font-bold tracking-widest uppercase text-sm text-black bg-neon-green text-center whitespace-nowrap"
            style={{ boxShadow: '0 0 20px rgba(57,255,20,0.5)' }}
          >
            Get a Quote
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
